import Toggles from '@core/scripts/modules/toggles';
import Expi, {ExperimentVariant} from '@core/scripts/modules/expi';

// Must stay identical to the backend's suggestion-source switch, otherwise a shopper sees the legacy
// overlay filled with Algolia suggestions, or the redesign filled with Smile's.
export const isSearchRedesignActive = () =>
    Toggles.isEnabled('SEARCH_REDESIGN_ONSITE_SEARCH')
    || Expi.getVariant('EXPI-214') === ExperimentVariant.VARIANT_B;
